import { useEffect, useState } from 'react';
import '../../App.css';
import './PublicAgendamentoForm.css';
import logo from '../../assets/img/logo-header.png';
import agenda from '../../assets/icons/agenda.png';

import CadastrosInternosService from '../../services/CadastrosInternosService';
import EspecialidadesService from '../../services/EspecialidadesService';
import HorariosService from '../../services/HorariosService';
import criarAgendamentoPublicDTO from "../../types/AgendamentoPublicDTO";

export default function PublicAgendamentoForm({ agendamento, onClose, onSubmit }) {

  const [form, setForm] = useState({
    idCadastro: "",
    nome: "",
    data: "",
    idEspecialidade: "",
    tempo: "",
    idHorario: ""
  });

  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [especialidades, setEspecialidades] = useState([]);
  const [horarios, setHorarios] = useState([]);
  const [blocosHorarios, setBlocosHorarios] = useState([]);
  const hoje = new Date().toISOString().split("T")[0];

  const idCadastro = localStorage.getItem("UserId");

  useEffect(() => {
    async function carregarDados() {
      if (!idCadastro) return;

      const cliente = await CadastrosInternosService.getById(idCadastro);
      const esp = await EspecialidadesService.getLista();

      const dataInicial =
        agendamento?.data || new Date().toISOString().split("T")[0];

      setForm(prev => ({
        ...prev,
        idCadastro,
        nome: cliente.NOME,
        data: dataInicial,
        idHorario: agendamento?.idHorario || ""
      }));

      setEspecialidades(esp);
      buscarHorarios(dataInicial);
    }

    carregarDados();
  }, [idCadastro, agendamento]);

  async function buscarHorarios(dataSelecionada) {
    if (!dataSelecionada) return;

    try {
      const response = await HorariosService.getDisponiveis(dataSelecionada);
      setHorarios(response || []);
      setBlocosHorarios([]);
    } catch (error) {
      console.error("Erro ao buscar horários:", error);
      setHorarios([]);
      setBlocosHorarios([]);
    }
  }

  function montarHorariosEmBlocos(horarios, tempoServicoEmMinutos) {
    if (!horarios || horarios.length === 0) return [];

    const blocos = [];
    const blocosNecessarios = Math.ceil(tempoServicoEmMinutos / 60);

    for (let i = 0; i < horarios.length; i++) {
      let valido = true;
      const bloco = [horarios[i]];

      for (let j = 1; j < blocosNecessarios; j++) {
        const atual = horarios[i + j];
        const anterior = horarios[i + j - 1];

        if (!atual) {
          valido = false;
          break;
        }

        const horaAtual = atual.horario.slice(0, 5);
        const horaAnterior = anterior.horario.slice(0, 5);

        const [h1, m1] = horaAnterior.split(":").map(Number);
        const [h2, m2] = horaAtual.split(":").map(Number);

        const diffMin = (h2 * 60 + m2) - (h1 * 60 + m1);

        if (diffMin !== 60) {
          valido = false;
          break;
        }

        bloco.push(atual);
      }

      if (valido) {
        blocos.push(bloco);
      }
    }

    return blocos;
  }

  function handleChange(e) {
    const { name, value } = e.target;

    setForm(prev => ({
      ...prev,
      [name]: value
    }));

    if (name === "data") {
      buscarHorarios(value);
      setForm(prev => ({ ...prev, idHorario: "" }));
    }

    if (name === "idEspecialidade") {
      const esp = especialidades.find(
        es => es.IDESPECIALIDADE === Number(value)
      );

      const tempo = esp?.tempo || "";

      setForm(prev => ({
        ...prev,
        tempo,
        idHorario: ""
      }));

      if (tempo > 60) {
        const blocos = montarHorariosEmBlocos(horarios, tempo);
        setBlocosHorarios(blocos);
      } else {
        setBlocosHorarios([]);
      }
    }
  }

  function validarCampos() {
    const newErrors = {};

    if (!form.data) newErrors.data = "Informe uma data";
    if (!form.idEspecialidade) newErrors.idEspecialidade = "Informe uma especialidade";
    if (!form.idHorario) newErrors.horario = "Informe um horário";

    return newErrors;
  }

  async function handleSubmit(e) {
    e.preventDefault();

    const newErrors = validarCampos();
    setErrors(newErrors);

    if (Object.keys(newErrors).length > 0) return;

    setLoading(true);

    try {
      const payload = criarAgendamentoPublicDTO({
        DATA: form.data,
        IDHORARIO: Number(form.idHorario),
        IDCADASTRO: Number(form.idCadastro),
        IDESPECIALIDADE: Number(form.idEspecialidade)
      });

      if (onSubmit) {
        await onSubmit(payload);
      }

    } catch (error) {
      console.error("Erro ao criar agendamento:", error);
    } finally {
      setLoading(false);
    }
    onClose();
  }

  return (
    <div className="Agendamento-form-Container">
      <div className="Agendamento-form-Fechar" onClick={onClose}>X</div>

      <img src={logo} alt="Logotipo" className="Agendamento-form-logo" />

      <div className="Agendamento-form-title">
        <img src={agenda} alt="agenda" className="icon" />
        Agendamentos
      </div>

      <div className="Agendamento-form-linha"></div>

      <form onSubmit={handleSubmit}>
        <div className="Agendamento-form-alinhamento">
          <label>Nome</label>
          <input
            name="nome"
            type="text"
            value={form.nome}  
            disabled
          />
        </div>

        <div className="Agendamento-form-alinhamento">
          <label>Data</label>
          <input
            name="data"
            type="date"
            className="date"
            min={hoje}
            value={form.data}
            onChange={handleChange}
          />
          {errors.data && <span className="erro">{errors.data}</span>}
        </div>

        <div className="Agendamento-form-alinhamento">
          <label>Especialidade</label>
          <select
            name="idEspecialidade"
            value={form.IDESPECIALIDADE}
            onChange={handleChange}
          >
            <option value="">Selecione uma especialidade</option>
            {especialidades.map(esp => (
              <option key={esp.IDESPECIALIDADE} value={esp.IDESPECIALIDADE}>
                {esp.DESCRICAO}
              </option>
            ))}
          </select>
          {errors.especialidade && <span className="erro">{errors.especialidade}</span>}
        </div>

        <div className="Agendamento-form-alinhamento">
          <label>Horário</label>

          {form.tempo <= 60 ? (
            <select
              name="idHorario"
              value={form.idHorario}
              onChange={handleChange}
              disabled={!form.data}
            >
              <option value="">Selecione um horário</option>
              {horarios.map(h => (
                <option key={h.idHorario} value={h.idHorario}>
                  {h.horario.slice(0, 5)} h
                </option>
              ))}
            </select>
          ) : (
            <select
              name="idHorario"
              value={form.idHorario}
              onChange={handleChange}
              disabled={!form.data}
            >
              <option value="">Selecione um horário</option>
              {blocosHorarios.map((bloco, index) => (
                <option key={index} value={bloco[0].idHorario}>
                  {bloco.map(h => h.horario.slice(0, 5)).join(" e ")}
                </option>
              ))}
            </select>
          )}

          {errors.horario && <span className="erro">{errors.horario}</span>}
        </div>

        <div className="Agendamento-form-alinhamento-button">
          <button type="submit" disabled={loading} className="Agendamento-button">
            {loading ? "Enviando..." : "Agendar"}
          </button>

          <button type="button" className="Agendamento-button" onClick={onClose}>
            Voltar
          </button>
        </div>
      </form>
    </div>
  );
}
